import './App.css';

import { Routes, Route } from 'react-router-dom';

import Header from './component/header'
import LandingPage from './component/landingpage';
import Footer from './component/footer'
import Privacypolicy from './component/privacypolicy';

function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path='/' element={<LandingPage />}></Route>
        <Route path='/privacy-policy' element={<Privacypolicy />}></Route>
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
